import { render } from "./Invoicing.vue?vue&type=template&id=bd75d9d4&scoped=true"
import script from "./Invoicing.vue?vue&type=script&lang=js"
export * from "./Invoicing.vue?vue&type=script&lang=js"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd75d9d4"]])

export default __exports__